import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/adaptify.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/checkaccess.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[lang]/components/NosProduitsTab.tsx");
